<template>
	<div id="app" v-cloak>
		<router-view></router-view>
	</div>
</template>
<script>
export default {
	name: 'App',
	data(){
		return {
		}
	},
}
</script>

<style>
*,*:after,*::before{
	box-sizing:border-box;
	-ms-box-sizing:border-box;
	-moz-box-sizing:border-box;
	-webkit-box-sizing:border-box;
}
*{
	text-decoration:none;
	list-style:none;
	margin:0;
	padding:0;
	border:none;
	line-height: 1;
	font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
	font-size:12px;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	word-break: break-all;
}
[v-cloak]{
	display: none;
}
.el-breadcrumb{
	margin-bottom: 20px;
}
.el-page-header{
	margin-bottom: 20px;
}
.btns{
	margin-bottom: 20px;
}
.l10{
	margin-left: 10px;
}
.bnone{
	margin-bottom: 0;
}
.el-page-header__left{
	display: flex;
	align-items: center;
}
.el-pagination{
	padding:0!important;
	margin-top: 20px;
}
.el-popconfirm__action{
	margin-top: 10px!important;
}
.thumb{
	display: flex;
	align-items: center;
}
.thumb img{
	display: flex;
	margin-right: 5px;
	height: 30px;
}
.avatar{
	display: flex;
	align-items: center;
}
.avatar img{
	display: flex;
	border-radius: 100%;
	margin-right: 5px;
	width: 30px;
	height: 30px;
}
.upLoad {
	width: 58px;
	height: 58px;
	line-height: 58px;
	border: 1px dotted rgba(0, 0, 0, 0.1);
	border-radius: 4px;
	background: rgba(0, 0, 0, 0.02);
	cursor: pointer;
}
.pictrue {
	width: 60px;
	height: 60px;
	border: 1px dotted rgba(0, 0, 0, 0.1);
	margin-right: 15px;
	display: inline-block;
	position: relative;
	cursor: pointer;
}
.pictrue img {
	width: 100%;
	height: 100%;
}
</style>
